import Vue from "vue";
import Vuelidate from "vuelidate";
import linkify from "vue-linkify";
// import VueViewer from "v-viewer";
// import VuePapaParse from "vue-papa-parse";

import { initializeApp } from "firebase/app";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./Mixins/filters";

// import "viewerjs/dist/viewer.css";
import "./assets/css/tailwind.css";

Vue.config.productionTip = false;

window.serverURL = process.env.VUE_APP_SERVER_URL;

Vue.use(Vuelidate);
// Vue.use(VueViewer);
Vue.directive("linkified", linkify);
// Vue.use(VuePapaParse);

initializeApp({
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FB_DB_URL,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_APP_ID,
  measurementId: process.env.VUE_APP_FB_MEASUREMENT_ID
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
